module.exports = "/fonts/Roboto-Regular.otf";